import {
  Box,
  Heading,
  Dialog,
  Button,
  Spinner,
  ButtonGroup,
} from "@chakra-ui/react";

import { useParams } from "react-router-dom";
import { CustomerForm } from "../CustomerForm";
import { NotFound } from "../../../404";
import { useEffect, useRef, useState } from "react";
import { useCustomer, useCustomerDelete } from "../../../hooks/useCustomers";

const CustomerEditForm = () => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const cancelRef = useRef(null);
  const customerNumber = parseInt(id || "0", 10);

  const customerQuery = useCustomer(customerNumber);
  const customerDelete = useCustomerDelete();

  useEffect(() => {
    if (customerDelete.isSuccess) {
      setOpen(false);
    }
  }, [customerDelete.isSuccess]);

  if (customerQuery.isLoading) {
    return <Spinner />;
  }

  if (!id || !customerQuery.data) {
    return <NotFound />;
  }

  return (
    <>
      <CustomerForm customer={customerQuery.data} setCustomer={() => {}} />
      <Button colorPalette="red" mt={8} onClick={() => setOpen(true)}>
        Slett kunde
      </Button>
      <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)} role="alertdialog">
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header fontSize="lg" fontWeight="bold">
              Slette kunde
            </Dialog.Header>

            <Dialog.Footer>
              {customerDelete.isPending && <Spinner />}
              {!customerDelete.isPending && (
                <ButtonGroup>
                  <Button ref={cancelRef} onClick={() => setOpen(false)}>
                    Avbryt
                  </Button>
                  <Button
                    colorPalette="red"
                    onClick={() => {
                      customerDelete.mutate({ customerNumber });
                    }}
                    ml={3}
                  >
                    Slett
                  </Button>
                </ButtonGroup>
              )}
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </>
  );
};

export default function CustomerEditPage() {
  return (
    <Box>
      <Heading as="h1" mb={4}>
        Endre kunde
      </Heading>
      <CustomerEditForm />
    </Box>
  );
}
